import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const NearbyServicesContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.contentGap};
  margin-top: ${barnesTheme.spacing.smallGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.contentGap} !important;
    margin-top: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const SubtitleText = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.body};
  color: ${barnesTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.body} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Hairline = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${barnesTheme.spacing.smallGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const ScoreCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${barnesTheme.colors.primary};
  background: transparent;

  @media print {
    width: 80px !important;
    height: 80px !important;
    border-radius: 50% !important;
    flex-shrink: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    border: 1px solid ${barnesTheme.colors.primary} !important;
    background: transparent !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 2px;

  @media print {
    display: flex !important;
    align-items: baseline !important;
    gap: 2px !important;
  }
`

export const ScoreValue = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 28px;
  color: ${barnesTheme.colors.primary};
  line-height: 1;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 28px !important;
    color: ${barnesTheme.colors.primary} !important;
    line-height: 1 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreMax = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: 12px;
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: 12px !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 4px !important;
  }
`

export const ScoreTitle = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 12px;
  color: ${barnesTheme.colors.primary};
  display: none;

  @media print {
    display: none !important;
  }
`

export const ScoreLabel = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 12px;
  color: ${barnesTheme.colors.accent};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 12px !important;
    color: ${barnesTheme.colors.accent} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScoreDescription = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.text};
  line-height: 1.4;
  text-align: center;
  max-width: 400px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1.4 !important;
    text-align: center !important;
    max-width: 400px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AmenityGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(3, auto);
  gap: ${barnesTheme.spacing.contentGap};

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    grid-template-rows: repeat(3, auto) !important;
    gap: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const AmenityCard = styled.div<{ $variant: 'grege' | 'bordered' }>`
  width: 100%;
  min-height: 100px;
  padding: 0;
  background: transparent;
  border: none;

  @media print {
    width: 100% !important;
    min-height: 100px !important;
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
  }
`

export const AmenityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-bottom: 6px !important;
  }
`

export const AmenityIconCircle = styled.div`
  display: none;

  @media print {
    display: none !important;
  }
`

export const AmenityNameRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media print {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100% !important;
  }
`

export const AmenityName = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 13px;
  color: ${barnesTheme.colors.accent};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 13px !important;
    color: ${barnesTheme.colors.accent} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AmenityScoreBadge = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: ${barnesTheme.fontSizes.medium};
  color: ${barnesTheme.colors.text};
  background: transparent;
  width: auto;
  height: auto;
  display: inline;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: ${barnesTheme.fontSizes.medium} !important;
    color: ${barnesTheme.colors.text} !important;
    background: transparent !important;
    width: auto !important;
    height: auto !important;
    display: inline !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AmenityCount = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: 8px;
  color: ${barnesTheme.colors.textLight};
  margin-top: 8px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: 8px !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AmenityProgressTrack = styled.div`
  height: 4px;
  background: ${barnesTheme.colors.border};
  margin-bottom: 8px;

  @media print {
    height: 4px !important;
    background: ${barnesTheme.colors.border} !important;
    margin-bottom: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AmenityProgressFill = styled.div<{ $width: number }>`
  height: 100%;
  width: ${({ $width }) => $width}%;
  background: ${barnesTheme.colors.primary};

  @media print {
    height: 100% !important;
    width: ${({ $width }) => $width}% !important;
    background: ${barnesTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AmenityPoiList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 0 !important;
  }
`

export const AmenityPoiItem = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.text};
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid ${barnesTheme.colors.border};

  &:last-child {
    border-bottom: none;
  }

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    color: ${barnesTheme.colors.text} !important;
    display: flex !important;
    justify-content: space-between !important;
    padding: 4px 0 !important;
    border-bottom: 1px solid ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    &:last-child {
      border-bottom: none !important;
    }
  }
`
